import React, { useEffect, useState } from 'react';
import ChatBot from './ChatBot';
import '../styles/ChatBotPage.css';

function ChatPage({ onClose }) {
  const [remainingQuota, setRemainingQuota] = useState(50); // 默认 50 次
  const [showCommandGuide, setShowCommandGuide] = useState(false); // 控制命令指南的显示
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="chatbot-page">
      {/* Header Section */}
      <div className="chatbot-page-header">
        <div className="chatbot-header-content">
          <h1 className="chatbot-main-title">MATAI Chat</h1>
        </div>
      </div>
      
      <div className="chatbot-wrapper">
        <ChatBot onClose={onClose} onQuotaChange={setRemainingQuota} />
      </div>
      
      {/* Chat Footer - Moved here as separate card */}
      <div className="chat-info-card">
        <div className="quota-section">
          <span>Remaining conversations: {remainingQuota}/50</span>
        </div>
        <div className="info-section">
          🔒 Privacy Protected: Your chat history is only saved during this browser session and will be cleared when you close the browser.
        </div>
        {/* 折叠的命令指南按钮 */}
        <div className="command-guide-toggle">
          <button 
            className="command-guide-btn"
            onClick={() => setShowCommandGuide(!showCommandGuide)}
            title="View special function commands"
          >
            🚀 Commands
          </button>
        </div>
      </div>
      
      {/* 折叠式功能命令指南 */}
      {showCommandGuide && (
        <div className="function-commands-overlay">
          <div className="function-commands-modal">
            <div className="modal-header">
              <h3>🚀 Special Function Commands</h3>
              <button 
                className="close-btn"
                onClick={() => setShowCommandGuide(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="modal-content">
              <p className="guide-intro">Use these special commands to directly access MATAI's prediction and design tools:</p>
              
              <div className="command-sections">
                <div className="command-section">
                  <h4>🔬 Material Property Prediction</h4>
                  <div className="command-format">
                    <strong>Format:</strong> <code>PREDICT: &#123;element1: percentage1, element2: percentage2, ...&#125;</code>
                  </div>
                  <div className="command-example">
                    <strong>Example:</strong> <code>PREDICT: &#123;Al: 20.0, Ti: 60.0, Cr: 15.0, Ni: 5.0&#125;</code>
                  </div>
                  <div className="command-description">
                    Predicts density, strength, and elongation for the given atomic composition (3-7 elements, total must equal 100%).
                  </div>
                </div>
                
                <div className="command-section">
                  <h4>🎯 Alloy Design Optimization</h4>
                  
                  <div className="command-subsection">
                    <strong>Minimize Density:</strong>
                    <div className="command-format">
                      <strong>Format:</strong> <code>DESIGN_MIN_DENSITY: min_elongation=X, min_specific_strength=Y</code>
                    </div>
                    <div className="command-example">
                      <strong>Example:</strong> <code>DESIGN_MIN_DENSITY: min_elongation=5.0, min_specific_strength=180.0</code>
                    </div>
                    <div className="command-description">
                      Finds lightweight alloy compositions while meeting ductility and specific strength requirements.
                    </div>
                  </div>
                  
                  <div className="command-subsection">
                    <strong>Maximize Toughness (Elongation × UTS):</strong>
                    <div className="command-format">
                      <strong>Format:</strong> <code>DESIGN_MAX_ELONGATION_UTS: max_density=X</code>
                    </div>
                    <div className="command-example">
                      <strong>Example:</strong> <code>DESIGN_MAX_ELONGATION_UTS: max_density=4.5</code>
                    </div>
                    <div className="command-description">
                      Finds alloys with maximum toughness (ductility × strength balance) under density constraints.
                    </div>
                  </div>
                  
                  <div className="command-subsection">
                    <strong>Maximize Specific Strength:</strong>
                    <div className="command-format">
                      <strong>Format:</strong> <code>DESIGN_MAX_SPECIFIC_STRENGTH: min_elongation=X, max_density=Y</code>
                    </div>
                    <div className="command-example">
                      <strong>Example:</strong> <code>DESIGN_MAX_SPECIFIC_STRENGTH: min_elongation=5.0, max_density=4.5</code>
                    </div>
                    <div className="command-description">
                      Finds alloys with maximum strength-to-weight ratio while meeting ductility and weight constraints.
                    </div>
                  </div>
                  

                </div>
              </div>
              
              <div className="command-tips">
                <h4>💡 Usage Tips:</h4>
                <ul>
                  <li>Commands are case-insensitive and can be used anywhere in your message</li>
                  <li>Prediction requires 3-7 elements with total composition = 100%</li>
                  <li>Design optimization may take 30-60 seconds to complete</li>
                  <li>You can ask follow-up questions about the results</li>
                  <li>Regular conversation works alongside these commands</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      
      <div className="chatbot-page-footer">
        <p>This AI assistant can help with general questions. For specific issues, please contact support.</p>
      </div>
    </div>
  );
}

export default ChatPage;
